<template>
  <PageHeader
    title="Edit Yarn"
    buttonText="Save Changes"
    buttonIcon="material-symbols:save"
    :buttonClick="onSubmit"
    :buttonDisabled="!meta.dirty"
  />

  <TabView class="bg-white rounded-md pb-2">
    <TabPanel header="Yarn Details">
      <MergeForm :type="'edit'" :values="values" :onSubmit="handleSubmit" :setErrors="setErrors" />
    </TabPanel>
  </TabView>
</template>

<script lang="ts" setup>
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import { useRouter } from 'vue-router'
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import MergeForm from '@/components/features/yarns/MergeForm.vue'
import { useMergeForm } from '@/composables/useMergeForm'
import { editYarn } from '@/api/yarns'
import type { ErrorResponse } from '@/types/error-types'

const router = useRouter()
const { values, loading, handleSubmit, setErrors, showToast, meta } = useMergeForm('edit')
const yarnId = router.currentRoute.value.params.id as string

const onSubmit = handleSubmit(async () => {
  loading.value = true

  await editYarn(values, yarnId)
    .then(() => {
      loading.value = false
      showToast('success', 'Yarn Edited!', 'You have successfully edited yarn.')
      router.push('/yarns')
    })
      .catch((error: { response?: { data: ErrorResponse } }) => {
        loading.value = false
        const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to edit yarn.'
        showToast('error', 'An error occurred!', errorMessages)
      })
})
</script>
